import type { Policy } from '@/permissions/types';

export const dashboardPolicies: Policy[] = [
  {
    name: 'view:admin_dashboard',
    evaluate: ({ user }) => ['SUPER_ADMIN', 'ADMIN'].includes(user.perfil),
  },
  {
    name: 'view:manager_dashboard',
    evaluate: ({ user }) =>
      ['COORDENADOR_ESCOLA', 'COORDENADOR_TURMA', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'].includes(user.perfil),
  },
  {
    name: 'view:student_dashboard',
    evaluate: ({ user }) => ['ALUNO', 'ALUNO_B2C'].includes(user.perfil),
  },
  {
    name: 'view:proofreader_dashboard',
    evaluate: ({ user }) =>
      ['PROFESSOR', 'CORRETOR_SAAS', 'COORDENADOR_SAAS', 'ADMIN', 'SUPER_ADMIN'].includes(user.perfil),
  },
];
